import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from '../../lead/lead.service';

import { StaffService } from '../staff.service';

const states = ["Kingston",
  "St Andrew",
  "St Catherine",
  "Portland",
  "St Mary",
  "St Thomas",
  "Hanover",
  "St Ann",
  "St James",
  "Trelawny",
  "Clarendon",
  "Manchester",
  "St Elizabeth",
  "Westmoreland"]

const cities = ["All", "Chennai", "Dharmapuri", "Krishnagiri", "Hosur", "Dindigul", "Palani", "Erode", "Dharapuram", "Karur", "Kulittalai", "Madurai", "Nagapattinam", "Myladuthurai", "Namakkal", "Nilgiris", "Uppathy", "Coonoor", "Gudalur", "Panthalur", "Udhagamandalam", "Perambalur", "Pudukkottai", "Ramanathapuram", "Salem", "Mettur", "Sivaganga", "Thanjavur", "Theni", "Thoothukudi", "Tiruchiorappalli", "Trichy", "Tirunelveli", "Tenkasi", "Tiruvannamalai", "Arani", "Thiruvarur", "Vellore", "Vaniyambadi", "Tirupattur", "Sholinghur", "Villupuram", "Tirukoilur", "Virudhunagar", "Rajapalayam", "Sivakasi", "Thiruvallur", "Tiruvallur", "Ambathur", "Ariyallur", "Krishnagiri", "Hosur", "Tiruppur", "Coimbatore", "Pollachi", "Anaimalai", "Coimbatore(North)", "Mettupalayam", "Sulur", "Cuddalore", "Chidambaram", "Chidambaram", "Kancheepuram", "Kanniyakumari", "Nagercoil"];

const regions = ["Zone A", "Zone B", "Zone C", "Zone D"]


@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})



export class ViewComponent implements OnInit, OnDestroy {
  @ViewChild('f') staffViewForm: NgForm;
  staffType: any = [{
    id: "True",
    name: 'Collection Staff Front End'
  }, {
    id: "False",
    name: 'Collection Staff Back End'
  }];
  isFrontEndStaff: Boolean = true;
  submitted = false;
  departments = []
  designations = []
  armWorkObj = [];
  scpWorkObj = [];
  products = [];
  buckets = [];
  basebranches = [];
  collectionStaffs: any = []
  collectionStaffBaseBranch: string = '';
  agencies = []
  showOtherRoleWork: Boolean = false;
  showARMWork: Boolean = false;
  public isPopUp;
  public selectedDepartment;
  public selectedDesignations;
  public selectDept;
  public selectDesg;
  public deactivatedReason;

  regions = regions
  cities = cities
  states = states
  stafId: string;
  private sub: any;

  staffDetails: any;



  constructor(private route: ActivatedRoute, private staffService: StaffService,
    private leadService: LeadService,
    private router: Router) {
    this.isPopUp = false;
    this.selectDept = [];
    this.selectDesg = [];
    this.selectedDesignations = [];
  }

  ngOnInit() {


    this.sub = this.route.params.subscribe(params => {
      this.stafId = params['id']; // (+) converts string 'id' to a number
    });


    this.leadService.fetchRegions().subscribe(
      (regions: any[]) => this.regions = regions,
      (error) => console.log(error)
    );
    this.staffService
      .fetchStates()
      .subscribe(stateListData => {
        this.states = stateListData;
      });

    this.staffService.getDepartmaents().subscribe(
      (departments: any[]) => this.departments = departments,
      (error) => console.log(error)
    );

    this.staffService.getStaffDetails(this.stafId).subscribe(
      (staff: any[]) => {
        this.staffDetails = staff;
        this.staffDetails.scpWorkObj = this.staffDetails.scopeOfWork;
        this.staffDetails.armWorkObj = this.staffDetails.armScopeOfWork;
        if (this.staffDetails.scpWorkObj.length > 0) {
          this.showOtherRoleWork = true

          // View Components show start Here
          for (let i = 0; i < this.staffDetails["scopeOfWork"].length; i++) {
            for (let j = 0; j < this.regions.length; j++) {
              if (this.regions[j]['id'] == this.staffDetails.scpWorkObj[i]['region']) {
                this.staffDetails.scpWorkObj[i]['region'] = this.regions[j]['name'];
              }
            }
            this.leadService
              .fetchCities()
              .subscribe(cities => {

                this.staffDetails.scpWorkObj[i]['cities'] = cities;

                for (let j = 0; j < cities.length; j++) {
                  if (cities[j]['id'] == this.staffDetails.scpWorkObj[i]['city']) {
                    this.staffDetails.scpWorkObj[i]['city'] = cities[j]['name'];
                  }
                }
              });

            this.leadService.fetchStates().subscribe(
              (states: any[]) => {
                this.staffDetails.scpWorkObj[i].states = states;
                for (let j = 0; j < states.length; j++) {
                  if (states[j]['id'] == this.staffDetails.scpWorkObj[i]['state']) {                    
                    this.staffDetails.scpWorkObj[i]['state'] = states[j]['name'];
                  }
                }

              },
              (error) => console.log(error)
            );

            
            this.staffService.getStaff(this.staffDetails.isFrontEndStaff).subscribe(
              (collectionStaffs: any[]) => {
                this.collectionStaffs = collectionStaffs
                //this.singlePointReportingManagerId = 'sfdsf';
              }, (error) => console.log(error)
            );
            // this.getCollectionStaff();
            //this.singlePointReportingManagerId = this.staffDetails.singlePointReportingManagerId;
          


  }

  //this.staffDetails.scpWorkObj[i]['region'] = "region";
  //this.staffDetails.scpWorkObj[i]['state'] = "state";
  //this.staffDetails.scpWorkObj[i]['city'] = "city";
  // View Components show ens Here

};
if (this.staffDetails.armWorkObj.length > 0) {
  this.showARMWork = true
};

this.assignDepartments(this.staffDetails['roles']);
      },
(error) => console.log(error)
    );



//  get base branches for both front end and back end staff
this.staffService.getBaseBranches().subscribe(
  (basebranches: any[]) => this.basebranches = basebranches,
  (error) => console.log(error)
);
  }

ngOnDestroy() {
  this.sub.unsubscribe();
}
goToEdit() {
  this.router.navigate(['edit-staff/' + this.staffDetails.id]);
}
goToHome() {
  this.router.navigate(['/']);
}
goToPopup() {
  this.isPopUp = true;
}
close_pop() {
  this.isPopUp = false;
}

deactivateUser() {
  let submitDeactivatedDetails = {
    "companyUserIds": ["'" + this.staffDetails.id + "'"],
    "description": this.deactivatedReason
  }
  console.log(submitDeactivatedDetails);
  this.staffService
    .postDeactivatedReason(submitDeactivatedDetails)
    .subscribe(result => {
      //this.toastr.success('Tempate saved successfully');
      this.isPopUp = false;
    });
}

assignDepartments = (roles) => {
  for (let i = 0; i < roles.length; i++) {
    for (let j = 0; j < this.departments.length; j++) {
      if (this.departments[j]['id'] === roles[i]['departmentId']) {
        if (this.selectDept.indexOf(this.departments[j]) < 0) {
          this.selectDept.push(this.departments[j]);
        }
      }
    }
  }

  this.selectedDepartment = this.selectDept;
  this.assignDesignations(roles);
}

assignDesignations(designations) {
  for (let i = 0; i < this.selectDept.length; i++) {
    this.selectDesg.push(this.selectDept[i]['id']);
  }
  this.staffService
    .getDesignations({ departmentId: this.selectDesg })
    .subscribe(
    (result: any[]) => {
      this.designations = result;
      /*for (let i = 0; i < designations.length; i++) {
        for (let j = 0; j < result.length; j++ ) {
          if (designations[i]['departmentId'] === result[j]['departmentId']) {
            if (this.selectedDesignations.indexOf(result[j]) < 0) {
              this.selectedDesignations.push(result[j]);
            }
          }
        }
      }*/
      for (let i = 0; i < this.staffDetails.roles.length; i++) {
        for (let j = 0; j < this.designations.length; j++) {
          if (this.staffDetails.roles[i].designationId == this.designations[j]['id']) {
            this.selectedDesignations.push(this.designations[j]);
          }
        }

      }
    },
    (error) => console.log(error)
    );
}
}



// WEBPACK FOOTER //
// ./src/app/staff/view/view.component.ts